const id = window?.rpReactPlugin?.productInfo?.id || 0;

// export the correct properties according to the id (wordpress post ID) provided by the react-plugin as variable in window
switch(id) {
  case 568:
    module.exports = require('./profiles/igloClassic');
    break;
  default:
    module.exports = require('./profiles/default');
}